<template lang="pug">
NotFound(
  v-if="otNotFound"
  entityType="ot"
  :entityId="$route.params.order_id"
)
.loader(v-else-if="loading")
  b-spinner(label='Cargando...' variant="danger")
div(v-else)
  div
    h1(id="title-ot").title
      | OT {{ $route.params.order_id }}
      | {{ ot.rma ? ' - RMA: ' + ot.rma : '' }}
      | - {{ ot.equipo ? 'SERIE: ' + ot.equipo.serial_number : '' }}
      | {{ ot.datos_ov_asociada ? '- OV: ' + ot.datos_ov_asociada.id : '' }}
      | - {{ ot.tipo_servicio.nombre }}
      | {{ ot.tecnico_asignado ? '- ' +ot.tecnico_asignado.first_name + ' ' + ot.tecnico_asignado.last_name : '' }}
    b-breadcrumb.d-flex.justify-content-start( :items="breadcrumbs" )
  .d-flex.cards
    b-card( body-class="main-card" ).first

      .main-content
        .info-bar
          // Sección para tablet-mobile
          .actions-scroll-tablet-section
            b-row.d-md-block.pb-3

              b-col(cols="12")
                  b-dropdown(
                  id="dropdown-actions"
                  text="Acciones"
                  variant="primary"

                  class="mt-2"
                )
                    template(v-slot:button-content)
                      b-icon-three-dots.circle-ellipsis.mr-2
                      span Acciones

                    //- b-dropdown-item(@click="printSummary()")
                    //-   p(class="text-print") Imprimir
                    //- b-dropdown-item(@click="generateCode()")
                    //-   PrintBarCode
                    .actions-container.px-4.pt-2
                      OTActionsIndex(
                        :ot="actionsOT"
                        :loading="loading"
                        @changed="() => handleChanged()"
                      )
                  b-col(cols="12" sm="12").pb-1.pt-3.px-0.w-full
                    .info-estado.w-full
                      .sub
                        .d-flex.gap10.estado-container
                          span.status( :style="getColor()" ) {{ textoEstadoOT }}
                          span.prioridad( v-if="ot.prioridad_asignacion" ) Prioridad de asignación
                          span.location {{ textoUbicaciónOT }}
          .sub
            .d-flex.gap10
              div.d-sm-block.d-md-block.d-lg-none
                .d-flex.d-sm-gap-3.d-d-sm-flex-column.align-items-start.mb-2.time-info-section
                    div.time-elapsed.info-box
                      span Tiempo<br>Estado Actual:
                      b-icon(:icon='currentStatusTime.icon' :variant='currentStatusTime.variant' font-scale="1.5")
                      span {{ currentStatusTime.time }}
                      StateTimeDetails.ml-n1(v-if="showStateTimeDetails" :detail="ot.detalle_tiempo_compuesto")
                    div.time-elapsed.info-box
                      span Tiempo<br>Total:
                      b-icon(:icon='totalTime.icon' :variant='totalTime.variant' font-scale="1.5")
                      span {{ totalTime.time }}
                    div.next-step.info-box
                      span Próximo Paso:
                      span {{ textoSiguientePaso }}
            div.d-none.d-lg-flex.desktop-estado-container
              span.status( :style="getColor()" ) {{ textoEstadoOT }}
              span.prioridad.ml-2( v-if="ot.prioridad_asignacion" ) Prioridad de asignación
              span.location.ml-2.mr-2 {{ textoUbicaciónOT }}
              .d-flex.gap-1.flex-column.flex-sm-row
                div.time-elapsed.info-box
                  span Tiempo<br>Estado Actual:
                  b-icon( :icon='currentStatusTime.icon' :variant='currentStatusTime.variant' font-scale="1.5" )
                  span {{ currentStatusTime.time }}
                  StateTimeDetails.ml-n1(v-if="showStateTimeDetails" :detail="ot.detalle_tiempo_compuesto")
                div.time-elapsed.info-box
                  span Tiempo<br>Total:
                  b-icon( :icon='totalTime.icon' :variant='totalTime.variant' font-scale="1.5" )
                  span {{ totalTime.time }}
                div.next-step.info-box
                  span Próximo Paso:
                  span {{ textoSiguientePaso }}
          .sub.d-lg-flex
            .alertas.d-flex.gap10.flex-column.flex-sm-row.mb-2
              //- alerta excepción
              .alerta( v-if="exception" :class="[ exception.class ]" class="alerta-cursor" @click="details3x3(exception)" )
                component(font-scale="1.5" :variant="exception.variant" :is="exception.component" )
                span {{ exception.tipo }}
              //- alerta presupuesto
              .alerta( v-if="ultimaCotizacion" :class="[ ultimaCotizacion.class ]" )
                component( font-scale="1.5" :variant="ultimaCotizacion.variant ? ultimaCotizacion.variant : 'success'" :is="ultimaCotizacion.component" )
                span Presupuesto {{ ultimaCotizacion.estado }}
        DetailsApproval(:exception="exception" :ot="ot")
        b-tabs(pills card :value="getCurrentTabFromRoute()" )
          b-tab( title="Resumen de Ingreso" )
            DiagnoseForm( v-if="ot" )
          b-tab( title="Diagnóstico y Reparación" lazy )
            Diagnostic(@changed="() => handleChanged()")
            SolicitudPartes
          b-tab( :title="ot.tipo_servicio.id === 4 ? 'Informe de Diagnóstico' : 'Informe de Orden de Trabajo'" lazy )
            InformePDF
          b-tab( v-if="ot.tipo_servicio.id === 4" title="Informe de Reparación" lazy )
            InformeReparacionPDF            
          b-tab(v-if="ot.datos_ov_asociada" title="Detalle de la OV")
            OVDetail
          b-tab( title="Históricos" )
            template(#title)
              b-spinner.mr-2(v-if="!loadedHistoricalData" small)
              span Históricos
            StatesHistory(:otId="$route.params.order_id" @loaded="loadedStatesHistory = true")
            Movements
            Exceptions(:otId="$route.params.order_id" @loaded="loadedExceptions = true")
            InventoryMovements(:otId="$route.params.order_id" @loaded="loadedInventoryMovements = true")
            ActionLogsFromOT(:otId="$route.params.order_id" :dateStart="ot.fecha_ingreso" :dateEnd="dateNow")

      .action-bar
        .actions-scroll-section
          b-row.d-sm-block.d-lg-none

            b-col(cols="5" sm="5")
                b-dropdown(
                id="dropdown-actions"
                text="Acciones"
                variant="primary"

                class="mt-2"
              )
                  template(v-slot:button-content)
                    b-icon-three-dots.circle-ellipsis.mr-2
                    span Acciones

                  b-dropdown-item(@click="printSummary()")
                    p(class="text-print") Imprimir
                  b-dropdown-item(@click="generateCode()")
                    PrintBarCode
                  OTActionsIndex(
                    :ot="actionsOT"
                    :loading="loading"
                    @changed="() => handleChanged()"
                  )
            b-col(cols="7" sm="7")
              .info-bar
                .sub
                  .d-flex.gap10
                    span.status( :style="getColor()" ) {{ textoEstadoOT }}
                    span.location {{ textoUbicaciónOT }}
          OTActionsIndex(
            :ot="actionsOT"
            :loading="loading"
            @changed="() => handleChanged()"
          ).d-none.d-md-block
        .print-buttons.mt-xl-auto.ml-xl-0.ml-md-auto.d-none.d-md-block
          ChangeDeliveryButton(:ot="ot", :public="false")
          ChangeServiceTypeButton.my-2(:ot="ot")
          b-button.to-ov.mb-2(variant="primary" @click="gotoOv()", v-if="ot && ot.datos_ov_asociada")
            font-awesome-icon(:icon="['fas', 'file-invoice-dollar']")
            | Detalle de la OV
          b-button.venta-directa.mb-2(
            v-if="esElegibleVentaCenter"
            variant="samtek-yellow"
            @click="gotoVentaCenter()"
          )
            font-awesome-icon.mr-2(:icon="['fas', 'shopping-cart']")
            | Venta Directa
          PrintBarCode.mb-2
          b-button.imprimir(disabled, v-if="loadingPrint")
            b-spinner(small='' type='grow')
            | Cargando...
          b-button.imprimir(@click="printSummary()" v-else)
            b-icon-printer.icon-printer
            | Imprimir
    b-card.ml-3.mb-5.warehouse-card(v-if="showEntryForm")
      EntryForm
    b-card.ml-3.mb-5.warehouse-card(v-if="showDepartureForm")
      DepartureForm
</template>

<script>
import { io } from 'socket.io-client'
import printJS from 'print-js'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import settings from '@/../settings'
import PrintBarCode from '@/components/PrintBarCode.vue'
import InformePDF from '@/components/OT/InformePDF.vue'
import InformeReparacionPDF from '@/components/OT/InformePDFReparacion.vue'
import Exceptions from '@/components/OT/ExceptionDetail.vue'
import InventoryMovements from '@/components/OT/InventoryMovementsHistory.vue'
import Diagnostic from '@/components/Diagnostic/Diagnostic.vue'
import SolicitudPartes from '@/components/AskParts/SolicitudPartes.vue'
import Movements from '@/components/Warehouse/Movements.vue'
import EntryForm from '@/components/Warehouse/EntryForm.vue'
import DepartureForm from '@/components/Warehouse/DepartureForm.vue'
import formatElapsedTime, {
  formatElapsedTimeInHours,
} from '@/utils/formatElapsedTime'
import NotFound from '@/components/Shared/NotFound.vue'
import DiagnoseForm from './DiagnoseForm.vue'
import StatesHistory from './StatesHistory.vue'
import ActionLogsFromOT from './ActionLogsFromOT.vue'
import OTActionsIndex from '../OTActions/OTActionsIndex.vue'
import DetailInternalQuotations from '../../Quotations/DetailInternalQuotations.vue'
import StateTimeDetails from './StateTimeDetails.vue'
import DetailsApproval from './ModalDetails3x3.vue'
import ChangeDeliveryButton from '../ClientOT/ChangeDeliveryButton.vue'
import ChangeServiceTypeButton from './ChangeServiceTypeButton.vue'
import OVDetail from './OVDetails.vue'

const [TAB_RESUMEN, TAB_HISTÓRICO] = [0, 4]
const alertProps = {
  Solicitado: {
    component: 'b-icon-exclamation-circle-fill',
    variant: 'warning',
    class: 'solicitado',
  },
  Aprobado: {
    component: 'b-icon-check-circle-fill',
    variant: 'success',
    class: 'aprobado',
  },
  Rechazado: {
    component: 'b-icon-x-circle-fill',
    variant: 'danger',
    class: 'rechazado',
  },
}

alertProps.SOLICITADO = alertProps.Solicitado
alertProps.APROBADO_INTERNO = alertProps.Aprobado
alertProps.RECHAZADO_INTERNO = alertProps.Rechazado
alertProps.APROBADO_CLIENTE = alertProps.Aprobado
alertProps.RECHAZADO_CLIENTE = alertProps.Rechazado

const PROPS_BY_COLOR = {
  green: { icon: 'check-circle', variant: 'estado-green' },
  yellow: { icon: 'exclamation-circle-fill', variant: 'estado-yellow' },
  red: { icon: 'exclamation-triangle-fill', variant: 'estado-red' },
}

export default {
  name: 'ViewOTIndex',
  components: {
    ChangeDeliveryButton,
    ChangeServiceTypeButton,
    DiagnoseForm,
    InformePDF,
    InformeReparacionPDF,
    Diagnostic,
    SolicitudPartes,
    StatesHistory,
    Movements,
    EntryForm,
    DepartureForm,
    PrintBarCode,
    OTActionsIndex,
    Exceptions,
    DetailInternalQuotations,
    InventoryMovements,
    ActionLogsFromOT,
    StateTimeDetails,
    DetailsApproval,
    OVDetail,
    NotFound,
  },
  data() {
    return {
      loadedStatesHistory: false,
      loadedExceptions: false,
      loadedInventoryMovements: false,
      exception: null,
      otNotFound: false,
      loading: true,
      loadingPrint: false,
      timeElapsed: 0,
      momentNow: null,
      // interval: null,
      updateTimeInterval: null,
      show: false,
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { path: '/' },
        },
        {
          text: 'Ordenes de Trabajo',
          to: { path: '/listar-ordenes' },
        },
        {
          text: `OT ${this.$route.params.order_id}`,
          active: true,
        },
      ],
    }
  },
  async created() {
    this.loading = true
    try {
      await this.getOT(this.$route.params.order_id)
    } catch (e) {
      if (e?.response?.status === 404) {
        this.otNotFound = true
      }
      return
    } finally {
      this.loading = false
    }
    const { user } = JSON.parse(localStorage.getItem('user'))
    const roles = user.groups.map((t) => t.id)
    if (roles.indexOf(2) > -1 && !this.ot.rma) this.isSupervisor = true
    if (roles.indexOf(3) > -1) this.isSupervisor = true
    await this.getOtExceptionsHistory(this.ot.ot).then((res) => {
      const firstException = res.data[0]
      this.exception = firstException
        ? this.mapAlertObject(firstException)
        : null
    })

    this.initWebsockets()
  },
  beforeDestroy() {
    // clearInterval(this.interval)
    clearInterval(this.updateTimeInterval)
  },
  destroyed() {
    if (!this.socket) return
    this.socket.disconnect()
  },
  methods: {
    ...mapActions('OTStore', ['getOT', 'getPdfIngreso']),
    ...mapActions('TechniciansStore', ['listTechnicians']),
    ...mapMutations('OTStore', ['SET_PRINT_NO_DISPLAY', 'SET_OT']),
    ...mapMutations('Exceptions', ['SET_SHOW_MODAL']),
    ...mapActions('OT', ['getOtExceptionsHistory']),
    async handleChanged() {
      this.loading = true
      await this.getOT(this.$route.params.order_id)
      this.loading = false
    },
    gotoVentaCenter() {
      this.$router.push({
        name: 'CheckoutVentaCenter',
        params: { order_id: this.ot.ot },
      })
    },
    gotoOv() {
      const ovId = this.ot?.datos_ov_asociada?.id
      if (ovId) {
        const url = this.$router.resolve({
          name: 'OVDetailView',
          params: { ov_id: ovId },
        }).href
        window.open(url, '_blank')
      }
    },
    details3x3(exception) {
      if (
        exception.tipo === 'Aprobación de 3x3' ||
        exception.tipo === 'Ampliación de garantía'
      ) {
        this.SET_SHOW_MODAL(true)
      }
    },
    async printSummary() {
      this.loadingPrint = true
      const resp = await this.getPdfIngreso(this.ot.ot)
      if (resp.status === 200) {
        // imprimir pdf de respuesta
        const file = new Blob([resp.data], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(file)
        printJS(fileURL)
      }
      this.loadingPrint = false
    },
    getColor() {
      const estado = this.ot?.estado?.estado
      if (estado) {
        return `background-color: ${estado.color_background}; color: ${estado.color_foreground};`
      }
    },
    getCurrentTabFromRoute() {
      return this.$route.query.from === 'excepciones'
        ? TAB_HISTÓRICO
        : TAB_RESUMEN
    },
    // Recibe un objeto excepción o presupuesto
    mapAlertObject(o) {
      return { ...o, ...alertProps[o.estado_code || o.estado] }
    },

    initWebsockets() {
      this.socket = io(settings.webSocketsUrl)

      this.socket.on('orden_trabajo:updated', async ({ id }) => {
        if (id === this.ot.ot) {
          await this.getOT(this.$route.params.order_id)
        }
        this.listTechnicians()
      })
    },
  },
  computed: {
    ...mapGetters('OTStore', ['ot']),
    ...mapGetters('Diagnosticos', ['showDiagnosticForm']),
    ...mapGetters('Warehouse', ['showEntryForm']),
    ...mapGetters('Warehouse', ['showDepartureForm']),
    ...mapGetters('Exceptions', ['showModal']),
    loadedHistoricalData() {
      return (
        this.loadedStatesHistory &&
        this.loadedExceptions &&
        this.loadedInventoryMovements
      )
    },
    actionsOT() {
      const newOt = this.ot // eslint-disable-line
      newOt.recepcionista = this.ot.recepcionista
        ? this.ot.recepcionista.id
        : null
      return newOt
    },
    textoSiguientePaso() {
      return this.ot?.estado?.estado?.siguiente_paso || '---'
    },
    textoEstadoOT() {
      return this.ot?.estado?.estado?.nombre || '---'
    },
    textoUbicaciónOT() {
      return this.ot?.ubicacion || '---'
    },
    currentStatusTime() {
      const time =
        this.ot?.tiempo_estados?.hora_compuesta_actual ||
        this.ot?.tiempo_estados?.hora_estado_actual
      if (!time) return { time: '00:00' }
      const data = PROPS_BY_COLOR[this.ot?.detalle_alerta?.state?.color] || {}
      return { ...data, time: formatElapsedTimeInHours(time, false) || '' }
    },
    totalTime() {
      const time = this.ot?.tiempo_estados?.hora_total
      if (!time) return { time: '0d 00:00:00' }
      const data = PROPS_BY_COLOR[this.ot?.detalle_alerta?.total?.color] || {}
      // const liveTime = time + this.timeElapsed
      return { ...data, time: formatElapsedTime(time, false) || '---' }
    },
    ultimaCotizacion() {
      const quotations = this.ot?.solicitud_cotizacion_interna
      if (!quotations || quotations.length === 0) return null

      const lastQuotation = quotations.at(-1)
      return this.mapAlertObject(lastQuotation)
    },
    dateNow() {
      return new Date().toISOString()
    },
    showStateTimeDetails() {
      return !!this.ot?.tiempo_estados?.hora_compuesta_actual
    },
    esElegibleVentaCenter() {
      if (!this.ot || !this.ot.equipo) return false
      // La elegibilidad depende del flag cambio_3x3 y el estado Reparado
      const is3x3 = this.ot.cambio_3x3 === true
      const isReparado = this.ot.estado?.estado?.nombre === 'Reparado'
      const isVendidaOrReservada =
        this.ot.equipo.vendido || this.ot.equipo.reservado
      return is3x3 && isReparado && !isVendidaOrReservada
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
@import '@/style/colors.scss';

::v-deep .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #f4c235;
  color: black;
  font-weight: bold;
  border-radius: 0.5rem;
}

::v-deep .card-header-pills {
  background-color: #f5f6fa;
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-between;
}
::v-deep .card-header {
  background-color: #fff;
  border-bottom: 0;
}

::v-deep .nav-item {
  margin: 6px;
}

::v-deep .nav-item a {
  color: #525252;
  font-weight: bold;
}

.title {
  font-size: 21px;
  font-weight: bold;
  color: var(--info);
}

.cards::v-deep {
  .card {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 5px;
    opacity: 1;
    border: none;
  }
  .warehouse-card {
    width: 45%;
    min-height: 80vh;
  }
}

.first {
  width: 100%;
  min-height: 400px;
}

.main-card {
  display: flex;
  height: calc(100vh - 176px);
  flex-direction: column-reverse;
  @include media-breakpoint-between(md, lg) {
    flex-direction: row;
  }
  @include media-breakpoint-up(xl) {
    flex-direction: row;
  }
}

.main-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  padding-right: 10px;

  padding-top: 25px;
  margin-top: 20px;
  border-top: 5px solid #e4e4e4;
  @include media-breakpoint-up(xl) {
    padding-top: 0;
    margin-top: 0;
    border-top: none;
    padding-right: 20px;
    margin-right: 20px;
    // border-right: 5px solid #E4E4E4;
  }

  &::v-deep .tab-pane {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }
}

.action-bar {
  display: flex;
  flex-direction: row;
  @include media-breakpoint-down(sm) {
    flex-direction: column;
  }
  @include media-breakpoint-between(md, lg) {
    flex-direction: column;
  }
  @include media-breakpoint-up(xl) {
    flex-direction: column;
  }
  .buttons-ot {
    border-radius: 5px;
    width: 100%;
    background: rgb(232, 235, 242);
    padding: 10px;
  }
}

.actions-scroll-section {
  @include media-breakpoint-between(md, lg) {
    max-width: calc(100% - 370px);
  }
  @include media-breakpoint-down(sm) {
    max-width: 100%;
  }
}
.text-print {
  color: #5b73e8;
  padding-left: 0 !important;
  margin-left: -5px;
  margin-bottom: 0px;
}
.print-buttons {
  display: flex;
  justify-content: space-between;
  gap: 10px;

  flex-direction: row;
  @include media-breakpoint-between(md, lg) {
    flex-direction: column;
  }
  @include media-breakpoint-up(xl) {
    flex-direction: column;
  }

  @include media-breakpoint-down(sm) {
    height: 40px;
    margin-top: 1rem;
  }

  &::v-deep button {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 15px;
    width: 170px;
    height: 50px;

    @include media-breakpoint-down(xs) {
      width: 120px;
    }
  }
  @include media-breakpoint-up(lg) {
    &::v-deep button {
      height: 45px;
    }
  }
}

::v-deep .imprimir {
  border: none;
  background: #1d4ed8 0% 0% no-repeat padding-box;
  color: white;
  font-size: 14px;
  font-weight: 600;
}
::v-deep .to-ov {
  border: none;
  color: black;
  font-size: 14px;
  font-weight: 600;
}

.main-content::v-deep .tab-content {
  padding: 20px 6px;
}

$split-info-bar-breakpoint: 1450px;

.info-bar {
  display: flex;
  align-items: start;
  margin-bottom: 2.5rem;
  justify-content: space-between;

  flex-direction: column;
  gap: 1rem;
  @media (min-width: $split-info-bar-breakpoint) {
    flex-direction: row;
    gap: max(10px, 2%);
  }
  @include media-breakpoint-down(sm) {
    align-items: center;
    margin-bottom: 0;
  }
  @include media-breakpoint-between(md, lg) {
    margin-bottom: 0;
    gap: 0;
    justify-content: space-evenly;
  }

  .status,
  .location,
  .prioridad {
    border-radius: 5px;
    min-width: 120px;
    height: 40px;
    font-weight: bold;
    padding: 0 10px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    @include media-breakpoint-down(sm) {
      margin-top: 7px;
      width: 90px;
      min-width: 0px;
    }
  }

  .sub {
    display: flex;
    justify-content: space-between;
    align-items: start;
    width: 100%;
    gap: normal;
    @media (min-width: $split-info-bar-breakpoint) {
      width: auto;
      gap: max(10px, 2%);
    }
    @include media-breakpoint-down(sm) {
      flex-direction: column;
      gap: 1rem;
      align-items: start;
    }
  }

  .status {
    background-color: #d4edfa;
    color: #0096db;
  }

  .location {
    background-color: #74788d;
    color: #f8f9fe;
  }

  .prioridad {
    background-color: $warning;
    color: color-yiq($warning);
    font-size: 75%;
  }
}

.time-elapsed {
  display: flex;
  align-items: center;
  gap: 10px;
  span {
    text-align: right;
    white-space: nowrap;
    @include media-breakpoint-down(sm) {
      text-align: left;
    }
  }
  span:last-of-type {
    width: auto;
  }
}

.next-step {
  display: flex;
  gap: 10px;
  span:first-of-type {
    text-align: right;
    width: min-content;
    @include media-breakpoint-down(sm) {
      text-align: left;
    }
  }
  span:last-of-type {
    font-weight: bold;
  }
}

.gap10 {
  gap: 10px;
}

.info-box {
  border: 1px solid #525252;
  background-color: #f8f9fe;
  padding: 0 8px;
  border-radius: 5px;
}

.alerta {
  display: flex;
  gap: 10px;
  // padding: 10px;
  // height: fit-content;
  border-radius: 5px;
  white-space: nowrap;
  height: 40px;
  justify-content: center;
  align-items: center;
  padding: 0 10px;

  &.solicitado {
    border: 1px solid #f1b44c;
    background-color: #fffbf3;
  }
  &.aprobado {
    border: 1px solid #88f14c;
    background-color: #f9fff3;
  }
  &.rechazado {
    border: 1px solid #f14c4c;
    background-color: #fff3f3;
  }
}

.icon-printer {
  @include media-breakpoint-up(sm) {
    margin-left: 25px;
  }
}
::v-deep .dropdown-menu.show {
  width: 250px;
}
.alerta-cursor {
  cursor: pointer;
}

::v-deep .b-table thead th {
  background-color: #dddde1;
  color: #525252;
  border: none;
}

::v-deep .b-table tbody td {
  border: none;
  background-color: #fff;
}
::v-deep .b-table tbody tr td:first-child {
  font-weight: bold;
  color: black;
}

.circle-ellipsis {
  border: solid 1px black;
  border-radius: 50%;
  background-color: black;
  color: #ffffff;
}

.time-info-section {
  @include media-breakpoint-between(md, lg) {
    /* grid-template-columns: repeat(3); */
    display: flex;
    gap: 1rem;
  }
}

@media (min-width: 750px) and (max-width: 1199px) {
  .actions-scroll-tablet-section {
    display: block;
    width: 100%;
  }
  .actions-scroll-section {
    display: none;
  }
  .action-bar {
    margin-top: 1.5rem;
    padding-left: 0.5rem;
  }
  .info-bar {
    padding: 0 20px;
  }
  .info-estado {
    width: 100%;
  }
  .estado-container {
    justify-content: space-between;
    width: 100%;
  }
  .desktop-estado-container {
    .status {
      display: none;
    }
    .location {
      display: none;
    }
  }
}
@media (min-width: 0px) and (max-width: 749px) {
  .actions-scroll-tablet-section {
    display: none;
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .actions-scroll-tablet-section {
    display: none;
    width: 100%;
  }
}

.venta-directa {
  justify-content: center;
}
</style>
